module.exports = __webpack_public_path__ + "img/logo.2689e075.png";